import { render, staticRenderFns } from "./ForgotPasswordView.vue?vue&type=template&id=4e51fbb1&lang=pug&"
import script from "./ForgotPasswordView.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordView.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPasswordView.vue?vue&type=style&index=0&id=4e51fbb1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports